export type RemoveFileDetail = {
  value: File;
  url: string;
};
